<template>
    <Poptip placement="bottom" word-wrap=true  v-model="visible" width="400">
        <span class="selcolor" ><Icon type="arrow-down-b"></Icon>
            <span  class="selcolor" v-if="!select.province.areaName">全国</span>
            <span  class="selcolor" v-if="select.province.areaName" >{{select.province.areaName}}</span>
            <span  class="selcolor" v-if="select.city.areaName" >/{{select.city.areaName}}</span>
            <span  class="selcolor" v-if="select.area.areaName" >/{{select.area.areaName}}</span>
        </span>
        <div slot="title" class="selcolor" >
            <span  class="selcolor"  @click="region(0,0)">全国</span>
            <span  class="selcolor" v-if="preselection.province.areaName"   @click="region(preselection.province.areaId,preselection.province.areaDeep)">/{{preselection.province.areaName}}</span>
            <span  class="selcolor" v-if="preselection.city.areaName"   @click="region(preselection.city.areaId,preselection.city.areaDeep)">/{{preselection.city.areaName}}</span>
            <span  class="selcolor" v-if="preselection.area.areaName" >/{{preselection.area.areaName}}</span>
        </div>
        <div  slot="content" height="auto">
                <Row>
                    <Col span="24" > 
                        <div style=" width:100%;word-break:break-all;word-wrap:break-word;white-space: pre-wrap; padding-bottom:10px;margin-bottom: 10px;border-bottom: 1px solid #eee;">
                            <Row>
                                <Col span="8"  v-for="item in preparation"  :key="item.areaId" > 
                                    <span  class="selcolorxx ml20" :style="item.areaId==select.area.areaId||item.areaId==select.city.areaId||item.areaId==select.province.areaId?'color:#57a3f3':''" @click="region(item.areaId,item.areaDeep)" >{{item.areaName}}</span>
                                </Col>
                            </Row> 
                        </div> 
                    </Col>
                </Row> 

                <Row>
                    <Col span="6"  offset="6">
                        <Button type="primary" @click="confirmarea()">确认</Button>
                    </Col>
                    <Col span="6" >
                        <Button type="ghost"  @click="regioncancel()">取消</Button>
                    </Col>
                </Row>
        </div>
    </Poptip>
</template>

<script>
// right-start右下
import province from '../../libs/area.json'
// right右中
export default {
  
    props: {
        limit: Boolean,
        cdata:Object
    },
    data() {
        return {
            visible:false,
            //预选数据
            preselection:{
              province:{},
              city:{},
              area:{}
            },
            //选中数据
            select:{
                province:{},
                city:{},
                area:{}
            },


            //显示的完整地址
            showArea:"全国",

            // //预选的省
            // selectProvince:{},
            // //预选的市
            // selectCity:{},
            // //预选的区
            // districtob:{},

            //准备选省市
            preparation:{},


            //区域总库库
            province:[],
        }
    },
    methods: {
        passval(data1,data2){
            data1.areaId=data2.areaId
            data1.areaName=data2.areaName
            data1.areaParentId=data2.areaParentId
            data1.areaDeep=data2.areaDeep
            data1.value=data2.value
            data1.label=data2.label
        },
        region(data,index) {
              if(index==0){
                this.preparation=JSON.parse(JSON.stringify(this.province));
                this.preselection.province={}
                this.preselection.city={}
                this.preselection.area={}
              }else if(index==1){
                this.province.map((itim)=>{
                  if(itim.areaId==data){
                    this.preselection.province=JSON.parse(JSON.stringify(itim))
                    this.preparation=JSON.parse(JSON.stringify(itim.children));
                    this.preselection.city={}
                    this.preselection.area={}
                  }
                })
              }else if(index==2){
                 this.preselection.province.children.map((itim)=>{
                  if(itim.areaId==data){
                    this.preselection.city=JSON.parse(JSON.stringify(itim))
                    this.preparation=JSON.parse(JSON.stringify(itim.children))
                    this.preselection.area={}

                  }
                })
              }else if(index==3){
                 this.preselection.city.children.map((itim)=>{
                  if(itim.areaId==data){
                    this.preselection.area=JSON.parse(JSON.stringify(itim))
                    this.preparation=[]
                    this.passval(this.select.province,this.preselection.province)
                    this.passval(this.select.city,this.preselection.city)
                    this.passval(this.select.area,this.preselection.area)
                    this.$emit('my-event',this.select) 
                    this.visible = false;
                  }
                })
              }
        },
        confirmarea(){
            
            //   this.passval(preselection.province,this.preselection.province)
            //   this.passval(preselection.city,this.preselection.city)
            //   this.passval(preselection.area,this.preselection.area)
            if(this.preselection.area.areaName!=""&&this.preselection.area.areaName!=null){  //区
                this.visible = false;
                this.passval(this.select.province,this.preselection.province)
                this.passval(this.select.city,this.preselection.city)
                this.passval(this.select.area,this.preselection.area)
                this.$emit('my-event',this.select) 
                //this.myClick(this.showArea)
                return
            }else if(this.preselection.city.areaName!=""&&this.preselection.city.areaName!=null){  //市
                
                if(this.limit){
                    if(this.preselection.city.children.length<1){
                        this.visible = false;
                        this.passval(this.select.province,this.preselection.province)
                        this.passval(this.select.city,this.preselection.city)
                        this.select.area={}
                        this.$emit('my-event',this.select)
                    }
                    return
                }
                this.visible = false;
                this.passval(this.select.province,this.preselection.province)
                this.passval(this.select.city,this.preselection.city)
                this.select.area={}
                this.$emit('my-event',this.select) 
                //this.myClick(this.showArea)
                return
            }else if(this.preselection.province.areaName!=""&&this.preselection.province.areaName!=null){  //省级
                if(this.limit){
                    return
                }
                this.visible = false; 
                
                this.passval(this.select.province,this.preselection.province)
                this.select.city={}
                this.select.area={}
                this.$emit('my-event',this.select) 
              
                return
            }else{  //国家级
                if(this.limit){
                        return
                    }
                this.select.province={}
                this.select.city={}
                this.select.area={}
                this.visible = false;
              
            } 
          },
          fuzhi(){
                this.select=JSON.parse(JSON.stringify(this.cdata))
                if(this.cdata.province.areaId){
                    this.province.forEach(itim =>{
                        if(itim.areaId==this.cdata.province.areaId){
                        this.preselection.province=JSON.parse(JSON.stringify(itim))
                            if(this.cdata.city.areaId){
                                this.preselection.province.children.forEach(itimcity =>{
                                    if(itimcity.areaId==this.cdata.city.areaId){
                                        this.preselection.city=JSON.parse(JSON.stringify(itimcity))
                                        if(this.cdata.area.areaId){
                                            this.preselection.city.children.forEach(itimarea =>{
                                                if(itimarea.areaId==this.cdata.area.areaId){
                                                    this.preselection.area=JSON.parse(JSON.stringify(itimarea))
                                                    this.preparation=[]
                                                }
                                                
                                            });
                                        }else{
                                        this.preparation =this.preselection.city.children 
                                        }



                                    }
                                    
                                });
                            }else{
                            this.preparation =this.preselection.province.children 
                            }


                        }
                    });
                }
          },
          regioncancel() {
              this.visible = false;
            },
        
    },
    watch:{
         cdata(){
            this.fuzhi()
         } 
    },
    mounted() {
        this.province = province;
        this.preparation=JSON.parse(JSON.stringify(this.province));
        this.fuzhi()
        
       
        
    }
}

// }else{
//                             this.preparation =this.preselection.province.children 
//                             }
//                 this.preselection.city
//                 this.preselection.area
</script>

<style>
.selcolor{color:#57a3f3;cursor: pointer; display: inline-block;}
.selcolorxx{color:#606b7a;cursor: pointer; display: inline-block;font-weight: 200}
.selcolorxx:hover{color:#57a3f3;}
.ml20{ margin-left: 20px;}
</style>


// WEBPACK FOOTER //
// src/views/main-components/arease.vue